import { loadStripe } from "@stripe/stripe-js";
import { api } from "@/lib/api";

// The publishable key comes from the backend so it always matches the account
// of the backend's secret key — a build-time env var can drift in production.
export const stripePromise = api
  .get("/payments/config")
  .then((r) => loadStripe(r.data.publishable_key))
  .catch(() => loadStripe(process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY));
